import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PROJECT_MANAGEMENT_URL } from '@insite-store360/shared';
import { Observable, catchError } from 'rxjs';
import { ErrorHandlerService } from './error-handler.service';

export interface UserDelegationMappingItem {
  id: number;
  userId: number;
  userName: string;
  userEmail?: string;
  delegateUserId: number;
  delegateUserName: string;
  delegateUserEmail?: string;
  countryId?: number;
  countryName?: string;
  isActive?: boolean;
  createdDateTime?: Date;
  updatedDateTime?: Date;
}

@Injectable({
  providedIn: 'root',
})
export class UserDelegationMappingService {
  private readonly URL_PATH = `${PROJECT_MANAGEMENT_URL}/user-delegation-mapping`;

  constructor(
    private http: HttpClient,
    private errorHandler: ErrorHandlerService
  ) { }

  public getAll(
    pageIndex?: number,
    pageSize?: number,
    searchValue?: string,
    userId?: number,
    countryId?: number
  ): Observable<{ data: UserDelegationMappingItem[]; paginatorValue: { totalData: number; totalCount: number } }> {
    let params = new HttpParams();
    if (pageIndex !== undefined && pageIndex !== null) {
      params = params.set('pageIndex', pageIndex.toString());
    }
    if (pageSize !== undefined && pageSize !== null) {
      params = params.set('pageSize', pageSize.toString());
    }
    if (searchValue && searchValue.trim() !== '') {
      params = params.set('searchValue', searchValue.trim());
    }
    if (userId !== undefined && userId !== null) {
      params = params.set('userId', userId.toString());
    }
    if (countryId !== undefined && countryId !== null) {
      params = params.set('countryId', countryId.toString());
    }
    return this.http
      .get<{ data: UserDelegationMappingItem[]; paginatorValue: { totalData: number; totalCount: number } }>(`${this.URL_PATH}/getAll`, { params })
      .pipe(catchError(this.errorHandler.handleError));
  }

  public create(
    userId: number,
    delegateUserId: number,
    countryId: number
  ): Observable<{ message: string; result: UserDelegationMappingItem }> {
    return this.http
      .post<{ message: string; result: UserDelegationMappingItem }>(`${this.URL_PATH}/create`, {
        userId,
        delegateUserId,
        countryId,
      })
      .pipe(catchError(this.errorHandler.handleError));
  }

  public update(
    id: number,
    userId: number,
    delegateUserId: number,
    countryId: number
  ): Observable<{ message: string; result: UserDelegationMappingItem }> {
    return this.http
      .put<{ message: string; result: UserDelegationMappingItem }>(`${this.URL_PATH}/update`, {
        id,
        userId,
        delegateUserId,
        countryId,
      })
      .pipe(catchError(this.errorHandler.handleError));
  }

  public delete(id: number): Observable<{ message: string }> {
    let params = new HttpParams();
    params = params.set('id', id.toString());
    return this.http
      .delete<{ message: string }>(`${this.URL_PATH}/delete`, { params })
      .pipe(catchError(this.errorHandler.handleError));
  }

  public updateStatus(id: number, isActive: boolean): Observable<{ message: string; result: UserDelegationMappingItem }> {
    return this.http
      .put<{ message: string; result: UserDelegationMappingItem }>(`${this.URL_PATH}/updateStatus`, {
        id,
        isActive,
      })
      .pipe(catchError(this.errorHandler.handleError));
  }
}
